import { defineComponent as v, computed as o, useAttrs as k, openBlock as s, createElementBlock as B, mergeProps as u, toHandlers as c, unref as n, renderSlot as p, createBlock as h, resolveDynamicComponent as y, withCtx as C } from "vue";
import { useTrackedListeners as b } from "../../composables/useTrackedListeners.js";
import { useRouterLinkComponent as R } from "@ds/plugin";
import { omit as L } from "../../utils/omit.js";
const $ = ["type"], E = /* @__PURE__ */ v({
  name: "RevButtonBase",
  inheritAttrs: !1,
  __name: "ButtonBase",
  props: {
    replace: { type: Boolean },
    to: {},
    prefetch: { type: Boolean },
    tracking: {},
    rel: {}
  },
  setup(t) {
    const r = t, i = R(), e = o(() => L(k(), ["onClick", "onMouseover", "onKeydown"])), { listeners: l } = b(r), m = o(() => !r.to && !e.value.href), f = o(() => e.value.disabled === !0), d = o(() => r.rel ? `${r.rel} noreferrer noopener` : "noreferrer noopener");
    return (a, g) => m.value ? (s(), B("button", u({ key: 0 }, e.value, {
      type: e.value.type || "button"
    }, c(n(l), !0)), [
      p(a.$slots, "default")
    ], 16, $)) : (s(), h(y(n(i)), u(
      { key: 1 },
      f.value ? {
        ...e.value,
        "aria-disabled": !0
      } : {
        ...e.value,
        to: t.to
      },
      {
        prefetch: t.prefetch,
        rel: d.value,
        replace: t.replace
      },
      c(n(l))
    ), {
      default: C(() => [
        p(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["prefetch", "rel", "replace"]));
  }
});
export {
  E as default
};
